import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { AuthService } from '../auth/auth.service';

/**
 * Guard für die öffentliche `/demo`-Landing-Page.
 *
 * 1. Nur im Demo-Build zulässig (`environment.demoEnabled`) — sonst → `/login`.
 * 2. Wer bereits ein Token hat (normaler Login ODER eine laufende Demo-Session), soll NICHT erneut
 *    eine Demo starten, sondern direkt in die App: Redirect auf das reguläre Login-Ziel
 *    ({@link AuthService.getRedirectUrlAfterLogin}). Erst ein wirklich abgemeldeter Besucher sieht
 *    die Willkommens-Seite.
 */
export const demoEnabledGuard: CanActivateFn = () => {
  const router = inject(Router);

  if (environment.demoEnabled !== true) {
    return router.createUrlTree(['/login']);
  }

  if (localStorage.getItem('token')) {
    const auth = inject(AuthService);
    return router.createUrlTree([auth.getRedirectUrlAfterLogin()]);
  }

  return true;
};
